export const keys = ( o ) => Object.keys( o );

export function filterUnique( value, index, self ) {
	return self.indexOf( value ) === index;
}

export const toPairs = ( o ) => Object.entries( o );
